import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { BaseComponent } from "BaseComponent";
import { fetchBranding, updatedSideOrBottmeAppMenu } from "BrandingAction";
import { fetchSettings } from "TicketAction";
import BrandingMenu from "./branding-menu";
import Appbranding from "./components/appbranding";
import Appmenu from "./components/appmenu";
import Webbranding from "./components/webbranding";
import SplashScreen from "./components/splash";
import { contentContainerWidth } from "Constants";

class Branding extends BaseComponent {
  constructor(props) {
    super(props);
    this.brandingRef = React.createRef();
    this.appMenuRef = React.createRef();
  }

  submit() {
    this.brandingRef.current.submit();
    // this.appMenuRef.current.submit()
  }

  // handleSelect(key) {
  //   this.setState({ selectedTab: key });
  // }

  renderBrandingList() {
    let { brandingMenus } = this.props;

    return brandingMenus.map((item, index) => {
      if (item) {
        return <BrandingMenu key={item.iconName} item={item} />;
      }
    });
  }

  render() {
    // console.log('contentContainerWidth',contentContainerWidth)

    return (
      <div className="content-parent-container">
        <div className="content-submenu vertical-line">
          <div>
            <ul className="list-group">{this.renderBrandingList()}</ul>
          </div>
        </div>

        <div
          className="content-subcontainer"
          // style={{ width: `${contentContainerWidth}px` }}
        >
          <Route
            path="/dashboard/branding/appbranding"
            render={(props) => (
              <Appbranding
                submitBrandingDataHandler={this.props.submitBrandingDataHandler}
                ref={this.brandingRef}
              />
            )}
            // component={Appbranding}
            // submitBrandingDataHandler={this.props.submitBrandingDataHandler}
            // ref={this.brandingRef}
          />
          {/* <Route
              path="/dashboard/branding/webbranding"
              component={Webbranding}
            /> */}
          <Route
            path="/dashboard/branding/appmenu"
            render={(props) => (
              <Appmenu
                submitBrandingDataHandler={this.props.submitBrandingDataHandler}
                ref={this.brandingRef}
                history={this.props.history}
              />
            )}
            // component={Appmenu}
            // submitBrandingDataHandler={this.props.submitBrandingDataHandler}
          />
          <Route
            path="/dashboard/branding/splash"
            render={(props) => (
              <SplashScreen
                submitBrandingDataHandler={this.props.submitBrandingDataHandler}
                ref={this.brandingRef}
                history={this.props.history}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    brandingData: state.brandingData,
    // colors:state.themeColors,
    // webcolors:state.webthemeColors,
    totalAppModules: state.totalAppModules,
    deviceSize: state.deviceSize,
    brandingMenus: state.brandingMenus,
  };
}

export default connect(
  mapStateToProps,
  { fetchBranding, updatedSideOrBottmeAppMenu, fetchSettings },
  null,
  { forwardRef: true }
)(Branding);
